import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Toolbar title building block.
 * Displays a title with optional subtitle.
 *
 * @example
 * ```html
 * <app-toolbar-title
 *   [title]="'Clientes de ruta ' + routeName()"
 *   [subtitle]="'Mostrando 50 resultados'"
 * />
 * ```
 */
@Component({
  selector: 'app-toolbar-title',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div>
      <h1 class="text-2xl font-semibold leading-8 tracking-tight">{{ title }}</h1>
      @if (subtitle) {
        <p class="text-secondary text-sm">{{ subtitle }}</p>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarTitleComponent {
  @Input() title = '';
  @Input() subtitle = '';
}
